// extracted by mini-css-extract-plugin
export default {"link":"Link-link-7742314bd2ff8a94e293d336ac2d4a60","linkActive":"Link-linkActive-1e5420d4502ef3f6027056df1756e409"};